(ns ncr.search.cheatsheet
  (:require
   ["copy-to-clipboard" :as copy-to-clipboard]
   [tick.core :as t]
   [uix.core.alpha :as uix]
   [ncr.amplitude :as amp]
   [ncr.etc.pf :as pf]
   [ncr.navigate :as n]
   [ncr.widgets.core :as w]))

(defn cheat-sheet []
  (let [start (uix/state nil)]
    [pf/c-popover
     {:class :ncr-search-cheat-sheet-popover
      :has-auto-width true
      :max-width "960px"
      :position :bottom-end
      :enable-flip false
      :on-show #(reset! start (t/instant))
      :on-hide
      #(when @start
         (amp/cheat-sheet! {"Duration" (t/millis (t/between @start (t/instant)))})
         (reset! start nil))
      :body-content
      [:div.ncr-search-cheat-sheet
       {:style {:max-height 460 :overflow-y :auto}}
       [pf/c-description-list
        (for
          [[title code]
           [["Search by value(brutto or netto)"
             "value:60.15"]

            ["Search by value between 55 and 65"
             "greater:55 less:65"]

            ["Search by value around(+/- 10%) 100"
             "around:100"]

            ["Search for all documents labeled with 'visa/' at the beginning"
             "label:visa/*"]

            ["Search for documents labeled as Sergey Vasiliev’s (SV) Visa with a date in March 2024"
             "label:visa/sv date:2024/03"]

            ["Search for SV's Visa documents not sent to Accounting in 2024"
             "label:visa/sv -label:booked date:2024"]

            ["Search for all Visa card documents not sent to Accounting and dated February or March 2024"
             "label:visa/* -label:booked date:2024/{02,03}"]

            ["Search documents by text (from title, description, and OCR-extracted content)"
             "text:hetzner"]

            ["Search documents by text extracted from document via OCR"
             "body:stuttgart"]

            ["Search documents in 'incoming' status (located in the Inbox or shared folders)"
             "in:incoming"]

            ["Search documents in 'accepted' status (located in the main archive)"
             "in:accepted"]

            ["Search documents in 'revoked' status (located in the main archive but marked as revoked)"
             "in:revoked"]

            ["Search for documents that have no labels"
             "-label:*"]

            ["Search for documents that have neither gross (brutto) nor net (netto) values"
             "-has:value"]

            ["Search for documents that have no attachments"
             "-has:attachments"]

            ["Search for documents dated in Q1 2024"
             "date:2024/{01,02,03}"]

            ["Adding '>' at the beginning of a query activates advanced query language, allowing the use of OR statements"]

            ["Search for items missing some of these properties"
             "> -has:date or -has:value or -has:attachments"]

            ["Alternatively, the same query (search for items missing some of these properties)"
             "> (date is null) or (value is null) or (attachments is null)"]]]

          ^{:key title}
          [pf/c-description-list-group
           [pf/c-description-list-term title]
           (when code
             [pf/c-description-list-description
              [pf/c-code-block
               [pf/c-code-block-code
                [:div.ncr-search-cheat-sheet-code
                 [:span.ncr-search-cheat-sheet-code-text code]
                 [:span.ncr-search-cheat-sheet-code-actions
                  [pf/c-clipboard-copy-button
                   {:variant :plain
                    :on-click #(copy-to-clipboard code)}
                   "Copy to clipboard"]
                  [pf/c-tooltip
                   {:content [:span "Execute search"]
                    :position :top
                    :enable-flip true}
                   [pf/c-button
                    {:variant :plain
                     :icon [w/c-mdi-icon {:class :mdi-18px :icon :play-circle}]
                     :on-click (fn [_] (n/push-search! code))}]]]]]]])])]]}
     [pf/c-button {:variant :plain}
      [pf/c-info-icon]]]))
